
<template>
  <section v-html="content" v-once />
</template>
<script>
export default {
  created() {
    this.content = unescape(`%3Ch1%3EToast%20%u63D0%u9192%3C/h1%3E%0A%3Ch2%20id%3D%22dai-ma-yan-shi%22%3E%u4EE3%u7801%u6F14%u793A%3C/h2%3E%0A%3Cdiv%20class%3D%22card%22%3E%3Ch3%20id%3D%22ji-chu-yong-fa%22%3E%u57FA%u7840%u7528%u6CD5%3C/h3%3E%0A%3Cpre%3E%3Ccode%20class%3D%22language-js%22%3E%3Cspan%20class%3D%22hljs-built_in%22%3Ethis%3C/span%3E.%24toast%28%7B%20%3Cspan%20class%3D%22hljs-attr%22%3Etext%3C/span%3E%3A%20%3Cspan%20class%3D%22hljs-string%22%3E%26%23x27%3B%u4EE3%u7801%u5199%u51FA%u6765%u662F%u7ED9%u4EBA%u770B%u7684%uFF0C%u9644%u5E26%u80FD%u5728%u673A%u5668%u4E0A%u8FD0%u884C%26%23x27%3B%3C/span%3E%20%7D%29%3B%0A%3C/code%3E%3C/pre%3E%0A%3C/div%3E`);
  },
mounted() {
    const anchors = [].slice.call(this.$el.querySelectorAll('h2, h3, h4, h5'));
    anchors.forEach(anchor => {
      anchor.addEventListener('click', this.scrollToAnchor);
    });
  },
  methods: {
    scrollToAnchor(event) {
      if (event.target.id) {
        this.$router.push({
          path: this.$route.path,
          hash: event.target.id
        })
      }
    }
  },

};
</script>
